import { Chart } from '@frontend/chart/types';

/** Duration values are open package_audit_pending timer seconds (same unit as other timer duration charts). */
export const VENDING_PACKAGE_TIMERS_DURATION_AUDIT_PENDING_BY_PRODUCT_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Product Alpha', data: [{ label: 'full_period', value: 345600 }] },
        { name: 'Product Beta', data: [{ label: 'full_period', value: 259200 }] },
        { name: 'Product Gamma', data: [{ label: 'full_period', value: 172800 }] },
        { name: 'Product Delta', data: [{ label: 'full_period', value: 86400 }] },
        { name: 'Product Epsilon', data: [{ label: 'full_period', value: 43200 }] },
        { name: 'Product Zeta', data: [{ label: 'full_period', value: 21600 }] },
        { name: 'Product Eta', data: [{ label: 'full_period', value: 7200 }] },
        { name: 'Product Theta', data: [{ label: 'full_period', value: 3600 }] }
    ]
};
